import {AfterViewInit, Component, OnInit} from '@angular/core';
import {StepService} from '../../services/step.service';
import {Router} from '@angular/router';
import {WpcheckRequestService} from '../services/request.service';
import {ElementService} from '../../services/element.service';
import {DecimalPipe} from '@angular/common';
import {EingabeStepComponent} from '../eingabe/eingabe.step.component';
import {PortalService} from '../../services/portal.service';
import {MatDialog} from '@angular/material/dialog';
import {ModeratRequestService} from "../../moderat/services/request.service";
import {VerbrauchsanalyseForm} from "../../verbrauchsanalyse/verbrauchsanalyse.form";
import {BestandsaufnahmeForm} from "../../moderat/bestandsaufnahme/bestandsaufnahme.form";
import {StepNavigationElement} from "../../step/step.navigation.element";
import {ModeratAnfrage} from "../../moderat/anfrage/moderat.anfrage";
import {FormConfig} from "../../form/form.config";
import {EnergyMapService} from "../../energy-map/services/energy.map.service";
import {StepNavigationComponent} from "../../step/step.navigation.component";

/**
 *
 */
@Component({
    selector: 'app-wpcheck-ergebnis',
    templateUrl: './ergebnis.component.html',
    providers: [DecimalPipe],
    standalone: false
})
export class ErgebnisComponent extends EingabeStepComponent implements OnInit, AfterViewInit {

  /**
   * some placeholders for the texts
   */
  placeholder: {};

  /**
   * data for the dialog registration
   */
  dialogData: any = {};

  /**
   * will be set to true if there is an error while talking to the backend.
   */
  hasError = false;

  /**
   * current portalId
   */
  portalId: string;

  /**
   * toggle if this is an internal project or not.
   */
  internalPortal: boolean;

  /**
   * hide report download
   */
  hideReportDownload: boolean;

  /**
   * Toggle to force the Dialog/NL-Box
   */
  forceDialog: boolean = false;

  /**
   * URL for the report to download
   */
  reportUrl: string;

  /**
   * Data for the accordion
   */
  accordion: {name: string, rating: string, text: string}[] = [];

  /**
   * the overall rating that comes from the backend
   */
  overallRating: string;

  /**
   * Rating for the moc teaser
   */
  mocRating: string;

  /**
   * url for opening the moc in the current window
   */
  mocUrl: string = '/{{portalId}}/moderat/wpcheck/start';

  /**
   * url for the moc in new window, but norml startpage
   */
  mocUrlMail: string;

  /**
   * holds the id of the html element where to jump to after click on dialog hint
   */
  idTargetElement: string = null;

  /**
   * toggle if we want to display the download module
   */
  showDownload: boolean;

  /**
   * list of topics for the faq
   */
  faqTopics: string[] = ['foerdermittel', 'photovoltaik', 'oekostrom', 'gebaeudehuelle', 'kaeltemittel'];

  /**
   * List of topics we show in the tabs for the pump infos
   */
  pumpInfoTopics: string[] = ['luft', 'erde', 'wasser', 'pvt'];

  /**
   * Fieldmappings towards the moc. List of fields that have other values than in the moc
   * Attention: If fields are changed in the MOC or WPC, check these mappings
   */
  mocFieldMappings: {[key: string]: {[key: string]: string}} = {
    'warmwasser_bereitungsart': {'zentral2': 'dezentral'},
    'fussbodenheizung_vorhanden': {'fussbodenheizung': 'ja', 'mischbetrieb': 'nein', 'konvektoren': 'nein'}
  };

  /**
   * @inheritDoc
   */
  constructor(protected stepService: StepService, protected router: Router, protected requestService: WpcheckRequestService,
              protected elementService: ElementService, protected portalService: PortalService, private decimalPipe: DecimalPipe,
              public dialog: MatDialog, private moderatRequestService: ModeratRequestService,
              protected energyMapService: EnergyMapService) {
    super(stepService, router, requestService, elementService, portalService);
  }

  /**
   * @inheritDoc
   */
  ngOnInit() {
    super.ngOnInit();

    // get the current portalId
    this.portalId = this.portalService.currentPortalId;
    this.internalPortal = this.portalService.isInternalPortal();
    this.hideReportDownload = this.portalService.getConfigAsBool('embed.newsletter.report.download');

    // should we force to see the dialog box
    this.forceDialog = this.portalService.getConfigAsBool('embed.newsletter.force');

    // check if there is input available and stop if not. Could happen if thirdparty cookies are not allowed
    if(!this.anfrage?.userInput || typeof this.anfrage.userInput !== "object" || Object.keys(this.anfrage.userInput).length === 0) {
      this.hasError = true;
      return;
    }

    this.requestService.backendService.getRequestId().subscribe(requestId => {
      // recalculate result
      this.requestService.backendService.result(this.anfrage, requestId).subscribe(data => {
        this.anfrage.result = data;
        this.initResult();
        this.requestService.setAnfrage(this.anfrage);
      }, error => {
        console.error("Could not get data from backend", error);
        this.hasError = true;
      });
    }, error => {
      // an error occured while talking to the backend.
      console.error("Could not get requestid from backend", error);
      this.hasError = true;
    });

    this.initDialogData();

    // set moc url
    this.mocUrl = this.mocUrl.replace(/\{\{portalId}}/, this.portalService.currentPortalId);
    this.mocUrlMail = this.portalService.getConfig("alladvisors.link.modernisierungscheck")?.replace(/\{\{portalId}}/, this.portalService.currentPortalId);
  }

  /**
  * @inheritDoc
  */
  ngAfterViewInit() {
    super.ngAfterViewInit();

    // scroll to the top after init
    this.elementService.scrollToElement(document.querySelector('.' + StepNavigationComponent.STEPNAVIGATION_CLASS));
  }

  /**
   * init the result data from the backend data.
   */
  initResult(): void {
    // reset accordion
    this.accordion = [];

    // map data of accordion to itteratable array and sort by rating
    if(this.anfrage.result?.data?.ratings?.accordion) {
      this.accordion = Object.keys(this.anfrage.result.data.ratings.accordion).map(key => {
        return {name: key, rating: this.anfrage.result.data.ratings.accordion[key]['rating'], text: this.anfrage.result.data.ratings.accordion[key]['text']}
      }).sort((a, b) => parseInt(a.rating) - parseInt(b.rating));
    }

    // overall rating
    this.overallRating = this.anfrage.result?.data?.ratings?.overall.length > 0 ? this.anfrage.result?.data?.ratings?.overall : null;

    // moc rating (for textpostfix), set only if teaser should be visible
    if(this.portalService.getConfigAsBool('wpcheck.moc.disabled') !== true) {
      this.initMocData();
    }

    // report
    this.reportUrl = this.anfrage.result?.report?? null

    // download module
    this.showDownload = !this.hideReportDownload && this.reportUrl && !this.internalPortal;

    //add css class to dialog or download module
    if(this.forceDialog) {
      this.idTargetElement = 'lead';
    }
    else if(this.showDownload) {
      this.idTargetElement = 'download';
    }
  }

  /**
   * Initializes the MOC anfrage object and the URL that leads to the MOC
   */
  initMocData(): void {
    // show navigation
    this.stepService.setShowNavigationPostElement(new StepNavigationElement('wpcheck.nav.moderat.', false, this.mocUrl));

    // set moc rating
    this.mocRating = this.anfrage.result?.data?.ratings?.pump_useful.length > 0 ? this.anfrage.result?.data?.ratings?.pump_useful : null;

    // set the moc anfrage and session in the current browser
    let mocAnfrage = this.moderatRequestService.getAnfrage();
    if(mocAnfrage.mode === ModeratAnfrage.MODE_WPCHECK) {
      // do not overwrite the existing object
      return;
    }

    // only set the fields here that are in the first section in the moc
    mocAnfrage = this.addInputToMocAnfrage(mocAnfrage, "verbrauchsanalyseInput", new VerbrauchsanalyseForm(this.energyMapService));

    // only set the fields here that are in the second section in the moc
    mocAnfrage = this.addInputToMocAnfrage(mocAnfrage, "bestandsanalyseInput", new BestandsaufnahmeForm());

    mocAnfrage.massnahmen = {};
    mocAnfrage.interesse = 'massnahme';
    mocAnfrage.interesseMassnahmen = 'heating';
    this.moderatRequestService.setAnfrage(mocAnfrage);

    // reset requestId if there is one
    this.moderatRequestService.backendService.resetRequestId();
  }

  /**
   * Add the input data to an field of the moc anfrage. They are filtered by the forms if they exists and some values are mapped to other values.
   *
   * @param mocAnfrage
   * @param field
   * @param form
   */
  addInputToMocAnfrage(mocAnfrage: ModeratAnfrage, field: string, form: FormConfig): ModeratAnfrage {
    const formFields = [].concat.apply([], form.getFields().map(field => field.getIds()));
    mocAnfrage[field] = {...this.anfrage.userInput};
    Object.keys(mocAnfrage[field]).forEach(id => {
      if(formFields.indexOf(id) === -1) {
        delete mocAnfrage[field][id];
      }
    });

    // map some fields that have other values in the moc than here
    Object.keys(this.mocFieldMappings).forEach(fieldName => {
      if(mocAnfrage[field].hasOwnProperty(fieldName) && this.mocFieldMappings[fieldName].hasOwnProperty(this.anfrage.userInput[fieldName])) {
        mocAnfrage[field][fieldName] = this.mocFieldMappings[fieldName][this.anfrage.userInput[fieldName]];
      }
    });

    return mocAnfrage;
  }

  /**
   * create data object that will be sent to the backend with the registration for the dialog
   */
  initDialogData(): void {
    this.requestService.backendService.getRequestId().subscribe(requestId => {
      this.dialogData = {
        requestId: requestId,
        bmOptinSource: window.location.href,
        doisource: 'wpc',
      };
    });
  }

  /**
   * Function is called if the users registered for the dialog
   */
  dialogRegistered(result: string): void {
    const anfrage = this.requestService.getAnfrage();
    anfrage.dialogResult = result;

    this.requestService.setAnfrage(anfrage);
    this.requestService.saveDataToServer();
  }
}
